<!-- --------------------------------------------------------------------------------
                      dialogMap2.vue

DESCRIPTIONS
  - displayed as a red button <Out of Range> in DevDetail-Map
  - pop up Map window, if AED dislocated
  - difference between dialogMap & dialogMap2
    - dialogMap is a location icon in device list table
    - dialogMap2 is a red/grey button in basic Info page
    
---------------------------------------------------------------------------------- -->
<template>
  <div class="text-center cRoot">

    <v-dialog v-model="bDialog" scrollable content-class="my-custom-dialog" :width="newWidth" :height="newHeight">
        <template  v-slot:activator="{ on, attrs }">
          <!---------------- displayed as icon/button in calling program ----------------->
          <v-btn v-if="btnEnabled==true" :disabled="!btnEnabled" width="98%" height="25px" color="red white--text" v-bind="attrs" v-on="on"
            class="ma-0 pa-0 elevation-0 text-capitalize rounded-xl fontB">Out of Range</v-btn>
          <v-btn v-else :disabled="!btnEnabled"  width="98%" height="25px" color="transparent" v-bind="attrs" 
            class="d-none"></v-btn>
        </template>

        <v-card width="98" height="auto" class="overflow-hidden rounded-xl">

          <!------------------------ Title Bar ---------------------------------->
          <v-card width="100%" height="25px" class="d-flex flex-row">
            <v-row>
              <v-col cols="2"><h5 class="ml-2 mt-1 pa-0 fontB"> Google Map</h5></v-col>
              <v-col cols="6"><v-sheet class="mt-1 text-center fontN">New Location:   {{ location }} {{ sMsg }}</v-sheet></v-col>
            </v-row>
            <v-btn icon x-small @click="bDialog= false" class="ma-1" style="position: absolute; right: 0;">
              <!-- <v-icon color="blue">mdi-close</v-icon></v-btn>  -->
              <svg-icon type="mdi" :path="pathClose" size="32"></svg-icon>
            </v-btn>
          </v-card>
        
          <!--------------------------- Map ---------------------------------->
          <v-card width="100%" :height="H2">
            <GoogleMap2 v-if="location !== '' && location !== '/'" width="100%" height="100%" 
            :ppLocation="location"/>
          </v-card>

        </v-card>

    </v-dialog>

  </div>
</template>

<script>
import GoogleMap2 from '@/components/Common/GoogleMap2'
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiMapMarker, mdiClose } from '@mdi/js';

  export default {
    name: 'dialogMap2',

    components: {
      GoogleMap2, SvgIcon
    },

    props: {
      location: {type: String, default: ''},
      installloc: {type: String, default: ''},
      newWidth: {type: String},
      newHeight: {type: String},
      enabled: {Boolean: false},               //if disabled, invisible button
    },

    data () {
      return {
        pathClose: mdiClose,
        bDialog: false,
        H2: this.newHeight - 20,
        sMsg: '',
        btnEnabled: this.enabled,
      }
    },

    methods: {
      // DESCRIPTION:  first function to call when entering this component
      btnOnDialog () {

      },

      sendEmit () {
        this.$emit('dialogEmit');
        this.bDialog = false;
      }
    },

    watch: {
      enabled: function(newVal) {
        this.btnEnabled = newVal;
      }
    },

    mounted() {
      if (this.location === "" && this.installloc === "") {
        //this.sMsg = "map address absent";
        this.sMsg = "";
      }
    }

  }
</script>

<style scoped>

.fontN {
  font-family: Montserrat; 
  font-style: normal; 
  font-weight: normal;   
  font-size: 0.8em;
  color: black;
}

.fontB {
  font-family: Montserrat; 
  font-style: normal; 
  font-weight: bold;  
  font-size: 0.8em; 
  color: black;
}


.cBorder {
  border: 1px solid grey;
}

body {
  overflow: hidden;
}


</style>
